import AddCircleIcon from '@mui/icons-material/AddCircle';
import CloseIcon from '@mui/icons-material/Close';
import {
  AccordionDetails,
  Box,
  Button,
  Chip,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Tooltip,
  Typography
} from '@mui/material';
import { FormLayoutBuilder, getFormData } from '@pihealth/common-ui-library';
import React, { useEffect, useState } from 'react';
import { useDocumentUploads } from 'src/components/StartUp/documentUpload/useDocumentUploads';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { getPoratlHost } from 'src/components/hooks/useUtil';
import { archLevel } from 'src/data/config';
import { useAppSelector } from 'src/store/hooks';
import forms from '../../../resources/forms.json';
import { DocumentUpload } from '../documentUpload/DocumentUpload';
import { useStartUpPacket } from './useStartUpPacket';

const BootstrapDialogTitle = (props: { [x: string]: any; children: any; onClose: any }) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2, pl: 3 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

const StudyInformation: React.FunctionComponent<any> = (sitestudypersonnelData: any) => {
  const [active2, setActive2] = useState(false);
  const [active, setActive] = useState(false);
  const sitestartUp = sitestudypersonnelData.sitestudypersonnelData;
  const studyId: any = useAppSelector((state: any) => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const { checkPermission } = usePermissionWrapper();
  const [open, setOpen] = React.useState(false);
  const [type, setType] = React.useState('');
  const [protocolUpDoc, setProtocolUpDoc] = useState<any>([]);
  const [protocolSynopsisDoc, setProtocolSynopsisDoc] = useState<any>([]);

  const { getDocListBySiteLevelArtifact } = useStartUpPacket();
  const { getAllISFDocInfoByArtifactNumberSiteLevelData } = useDocumentUploads();
  const handleClickOpen = (typeData: string) => {
    setType(typeData);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const getUploadedDocuments = async (artifactName: string, artifactNumber: any = null) => {
    const result: any =
      archLevel == 'sponsor'
        ? await getDocListBySiteLevelArtifact({
            site_id: selectedSite,
            study_id: studyId,
            country: selectedCountry,
            artifactName,
            application: process.env.REACT_APP_NAME,
            module_section_related: 'START UP PACKET',
            parent_entity_related: ''
          })
        : await getAllISFDocInfoByArtifactNumberSiteLevelData({
            site_id: selectedSite,
            study_id: studyId,
            country: selectedCountry,
            artifactName,
            artifactNumber,
            originally_uploaded: false,
            application: process.env.REACT_APP_NAME,
            module_section_related: 'START UP PACKET',
            parent_entity_related: ''
          });
    if (result.isSuccess) {
      const selectedDocsList =
        result?.data && result?.data?.selected_data.length > 0 ? getSortedDocsList(result?.data?.selected_data) : [];
      if (artifactName === 'Protocol') {
        setProtocolUpDoc(selectedDocsList);
      } else {
        setProtocolSynopsisDoc(selectedDocsList);
      }
    } else {
      if (artifactName === 'Protocol') {
        setProtocolUpDoc([]);
      } else {
        setProtocolSynopsisDoc([]);
      }
    }
  };
  const getSortedDocsList = (result: any) => {
    const resultCopy = [...result];
    const checkDocList = resultCopy.sort(
      (a: any, b: any) => +new Date(a.document_data.created_on) - +new Date(b.document_data.created_on)
    );
    const oldestDoc = checkDocList[0];
    const listFiltered =
      archLevel == 'sponsor'
        ? result.filter((doc: any) => oldestDoc.document_data.tmf_document_id !== doc.document_data.tmf_document_id)
        : result.filter((doc: any) => oldestDoc.document_data.isf_document_id !== doc.document_data.isf_document_id);
    return [oldestDoc, ...listFiltered];
  };

  const openDoucmentViewer = (item: any) => {
    window.parent.postMessage(
      {
        action: 'PUSH_APP',
        slug_id: archLevel == 'site' ? process.env.REACT_APP_ISF_SLUG : process.env.REACT_APP_ETMF_SLUG,
        //Send Document ID and Study ID only for the Study Level document viewing
        viewerDocument: {
          document_id: item.document_data.id,
          study_id: studyId,
          site_id: selectedSite,
          country: selectedCountry,
          ...(archLevel == 'site' && {
            file_master_id: item.file_master.id,
          })
        }
      },
      getPoratlHost()
    );
  };

  useEffect(() => {
    if (selectedSite !== '') {
      if (archLevel == 'sponsor') {
        getUploadedDocuments('Protocol');
        getUploadedDocuments('Protocol Synopsis');
      } else {
        getUploadedDocuments('Protocol', '01.02.01');
        getUploadedDocuments('Protocol Synopsis', '04.01.01');
      }
    }
  }, [selectedSite]);

  useEffect(() => {
    if (archLevel == 'sponsor') {
      getUploadedDocuments('Protocol');
      getUploadedDocuments('Protocol Synopsis');
    } else {
      getUploadedDocuments('Protocol', '01.02.01');
      getUploadedDocuments('Protocol Synopsis', '04.01.01');
    }
  }, []);
  const formGroup = forms.startUpPacket_StudyInformation;
  const { formFields, defaultValues = {}, rules } = getFormData(formGroup.groups);
  const { groups } = formFields;

  return (
    <AccordionDetails className="study-information">
      <Typography>
        <Box component="form" noValidate autoComplete="off">
          {Object.keys(sitestartUp).length > 0 && (
            <>
              <FormLayoutBuilder
                isDisableRule
                initialValues={sitestartUp.study.sponsor_name ? sitestartUp.study : defaultValues}
                rules={rules}
                groups={groups}
              />
              <Grid container className="modal-actions">
                <Grid md={12}>
                  <div>
                    <Tooltip title="Upload Document" placement="top" arrow>
                      <IconButton
                        aria-label="add"
                        color="primary"
                        size="large"
                        onClick={() => handleClickOpen('Protocol Synopsis')}
                        disabled={!checkPermission('upload_protocol')}
                      >
                        <AddCircleIcon fontSize="inherit" />
                      </IconButton>
                    </Tooltip>
                    {protocolSynopsisDoc.length !== 0 ? (
                      checkPermission('view_startUp_packet') ? (
                        <Button className="modal-btn active" onClick={() => openDoucmentViewer(protocolSynopsisDoc[0])}>
                          Protocol Synopsis
                        </Button>
                      ) : (
                        <span className="disable-paragraph">Protocol Synopsis</span>
                      )
                    ) : (
                      <span className="disable-paragraph">Protocol Synopsis</span>
                    )}
                    <div />
                    {protocolSynopsisDoc.length > 1 ? (
                      checkPermission('view_startUp_packet') ? (
                        protocolSynopsisDoc
                          .slice(1)
                          .map((item: any, index: number) => (
                            <Chip
                              sx={{ m: 0.3, maxWidth: '50%' }}
                              key={index}
                              label={
                                archLevel == 'sponsor'
                                  ? item.document_data.tmf_document_name
                                  : item.document_data.isf_document_name
                              }
                              variant="outlined"
                              onClick={() => openDoucmentViewer(item)}
                              size="small"
                              color="primary"
                            />
                          ))
                      ) : (
                        <></>
                      )
                    ) : (
                      <></>
                    )}
                    <PopupComponent aria-labelledby="customized-dialog-title" open={open} maxWidth="md">
                      <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
                        Documents / Upload Document
                      </BootstrapDialogTitle>
                      <DialogContent>
                        <DocumentUpload
                          selectedSite={selectedSite}
                          type={type}
                          level="Site"
                          setOpen={setOpen}
                          open={open}
                          active={active}
                          setActive={setActive}
                          active2={active2}
                          setActive2={setActive2}
                          getUploadedDocuments={getUploadedDocuments}
                          setProtocolSynopsisDoc={setProtocolSynopsisDoc}
                        />
                      </DialogContent>
                    </PopupComponent>
                  </div>
                </Grid>
              </Grid>
              <Grid container className="modal-actions">
                <Grid md={12}>
                  <div>
                    <Tooltip title="Upload Document" placement="top" arrow>
                      <IconButton
                        aria-label="add"
                        color="primary"
                        size="large"
                        onClick={() => handleClickOpen('Protocol')}
                        disabled={!checkPermission('upload_protocol')}
                      >
                        <AddCircleIcon fontSize="inherit" />
                      </IconButton>
                    </Tooltip>
                    {protocolUpDoc.length !== 0 ? (
                      checkPermission('view_startUp_packet') ? (
                        <Button className="modal-btn active" onClick={() => openDoucmentViewer(protocolUpDoc[0])}>
                          Protocol
                        </Button>
                      ) : (
                        <span className="disable-paragraph">Protocol</span>
                      )
                    ) : (
                      <span className="disable-paragraph">Protocol</span>
                    )}
                    <div />
                    {protocolUpDoc.length > 1 ? (
                      checkPermission('view_startUp_packet') ? (
                        protocolUpDoc
                          .slice(1)
                          .map((item: any, index: number) => (
                            <Chip
                              sx={{ m: 0.3, maxWidth: '50%' }}
                              key={index}
                              label={
                                archLevel == 'sponsor'
                                  ? item.document_data.tmf_document_name
                                  : item.document_data.isf_document_name
                              }
                              variant="outlined"
                              onClick={() => openDoucmentViewer(item)}
                              size="small"
                              color="primary"
                            />
                          ))
                      ) : (
                        <></>
                      )
                    ) : (
                      <></>
                    )}
                  </div>
                </Grid>
              </Grid>
            </>
          )}
        </Box>
      </Typography>
    </AccordionDetails>
  );
};

export default StudyInformation;
